import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp, } from "lucide-react";
const sizeStyles = {
    sm: { button: "h-8 w-8 p-0", icon: "h-3! w-3!" },
    md: { button: "h-10 w-10 p-0", icon: "h-4! w-4!" },
    lg: { button: "h-12 w-12 p-0", icon: "h-6! w-6!" },
};
export function NavigationArrow({ swiper, action, direction, size = "md", className, }) {
    const Icon = direction === "up"
        ? ChevronUp
        : direction === "down"
            ? ChevronDown
            : direction === "right"
                ? ChevronRight
                : ChevronLeft;
    return (_jsx(Button, { variant: "outline", size: "icon", "aria-label": `Section Swiper ${direction} Aria`, title: `Section Swiper ${direction}`, onClick: () => action === "next" ? swiper?.slideNext() : swiper?.slidePrev(), className: cn("cursor-pointer rounded-xl bg-transparent text-gray-100 backdrop-blur-xl", sizeStyles[size].button, className), children: _jsx(Icon, { className: sizeStyles[size].icon }) }));
}
